import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ReactiveFormsModule, UntypedFormGroup} from '@angular/forms';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import {environment} from "../../../../environments/environment";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";


@Component({
    selector: 'app-textarea',
    templateUrl: './textarea.component.html',
    styleUrls: ['./textarea.component.scss'],
	  standalone: true,
	  imports: [ReactiveFormsModule, FaIconComponent]
})
export class TextareaComponent implements OnInit, OnDestroy {
	@Input() id: string;
	@Input() label: any;
	@Input() customFormGroup: UntypedFormGroup;
	@Input() noteText: string;
	@Input() showMaxLength = false;
	@Input() maxReferenceLength = 1;
	@Input() maxLength?: number;
	@Input() placeholder = '';
	@Input() rows = 10;
  @Input() columns;
  cols  = 40;
	@Input() readonly = false;
  @Input() disabled = false;
  @Input() infoText: string;
  @Input() isTextbausteinEdit = false;
  @Input() autoResize = false;

  faInfo = faInfoCircle;

  onAutoResize(event: Event): void {
    const el = event.target as HTMLTextAreaElement;
    el.style.height = 'auto';
    el.style.height = el.scrollHeight + 'px';
  }

	currentLength = 0;
	destroySub$: Subject<void> = new Subject<void>();

  htmlFieldName : string;

	ngOnDestroy(): void {
		this.destroySub$.next();
		this.destroySub$.complete();
	}

	ngOnInit(): void {
    this.htmlFieldName = TextareaComponent.getHtmlTextAreaIdByFieldName(this.id)
		this.customFormGroup
			.get(this.id)
			.valueChanges.pipe(takeUntil(this.destroySub$))
			.subscribe((value) => {
				if (value) {
					this.currentLength = value.length;
				} else {
					this.currentLength = 0;
				}
			});
    this.cols = this.columns? parseInt(this.columns) : 40;
	}

	getFormElement(id: string) {
		return this.customFormGroup.get(id);
	}

  getCurrentLength() : number {
    return this.getFormElement(this.id).value?.length;
  }

  static getHtmlTextAreaIdByFieldName(fieldName: string){
    return "input"+fieldName
  }

  protected readonly environment = environment; // todo: from config?

  getTitle(): string{
    return this.label;
  }
}
